import { SignalRTypes, SportTypesActionTypes } from "../actions";

const initState = {
  error: null,
  loadingSportTypes: false,
  loadingMainTournamentEvents: false,
  sportTypes: [],
  mainTournamentEvents: [],
  sportData: null,
};

const sportTypes = (state = initState, action) => {
  switch (action.type) {
    case SportTypesActionTypes.Init:
      return {
        ...state,
        error: null,
        loadingSportTypes: false,
        sportTypes: [],
        sportData: null,
      };

    case SignalRTypes.SportTypes_Request:
      return {
        ...state,
        loadingSportTypes: true,
        sportTypes: [],
        error: null,
      };

    case SportTypesActionTypes.SportTypes_Success:
      return {
        ...state,
        loadingSportTypes: false,
        sportTypes: action.sportTypes,
        error: null,
      };

    case SportTypesActionTypes.SportTypes_Error:
      return {
        ...state,
        loadingSportTypes: false,
        sportTypes: [],
        error: action.error,
      };
    case SportTypesActionTypes.Set_Sport:
      return {
        ...state,
        sportData: action.item,
      };
    case SignalRTypes.Main_Tournament_Events_Request:
      return {
        ...state,
        loadingMainTournamentEvents: true,
        mainTournamentEvents: [],
        mainTournamentError: null,
      };
    case SportTypesActionTypes.Main_Tournament_Events_Success:
      return {
        ...state,
        loadingMainTournamentEvents: false,
        mainTournamentEvents: action.mainTournamentEvents,
        mainTournamentError: null,
      };
    case SportTypesActionTypes.Main_Tournament_Events_Error:
      return {
        ...state,
        loadingMainTournamentEvents: false,
        mainTournamentEvents: [],
        mainTournamentError: action.error,
      };
    case SignalRTypes.OnUpcomingDraws:
      return {
        ...state,
        loadingUpcomingDraws: action.addNewList ? false :true,
        appendNewList :action.addNewList ? true :false,
        // upcomingDrawsEvents: {},
        upcomingDrawsEventsError: null,
        addNewList: action.addNewList,
      };
    case SignalRTypes.OnUpcomingDrawsSuccess:
      return {
        ...state,
        loadingUpcomingDraws: false,
        appendNewList :false,
        upcomingDrawsEvents: action.upcomingDrawsEvents,
        upcomingDrawsEventsError: null,
      };
    case SignalRTypes.OnUpcomingDrawsError:
      return {
        ...state,
        loadingUpcomingDraws: false,
        appendNewList :false,
        upcomingDrawsEvents: undefined,
        upcomingDrawsEventsError: action.error,
      };
    case SignalRTypes.Get_Draws_Categories_And_Tournaments_Request:
      return {
        ...state,
        loadingDrawsCategories: true,
        drawsCategories: undefined,
        drawsCategoriesError: null,
      };
    case SignalRTypes.Get_Draws_Categories_And_Tournaments_Success:
      return {
        ...state,
        loadingDrawsCategories: false,
        drawsCategories: action.drawsCategories,
        drawsCategoriesError: null,
      };
    case SignalRTypes.Get_Draws_Categories_And_Tournaments_Error:
      return {
        ...state,
        loadingDrawsCategories: false,
        drawsCategories: undefined,
        drawsCategoriesError: action.error,
      };
    case SignalRTypes.Get_Lucky_Numbers_Event_Result_Request:
      return {
        ...state,
        loadingEventResult: action.addToEvents ? false : true,
        // luckyNumbersEventResult: undefined,
        luckyNumbersEventResultError: null,
        addToEvents: action.addToEvents,
      };
    case SignalRTypes.Get_Lucky_Numbers_Event_Result_Success:
      return {
        ...state,
        loadingEventResult: false,
        luckyNumbersEventResult: action.luckyNumbersEventResult,
        luckyNumbersEventResultError: null,
      };
    case SignalRTypes.Get_Lucky_Numbers_Event_Result_Error:
      return {
        ...state,
        loadingEventResult: false,
        luckyNumbersEventResult: undefined,
        luckyNumbersEventResultError: action.error,
      };
      case SignalRTypes.Get_Draw_Odds_Request:
        return {
          ...state,
          loadingDrawOddsDetails: true,
        };
      case SignalRTypes.Get_Draw_Odds_Response:
        return {
          ...state,
          loadingDrawOddsDetails: false,
        };
    case SignalRTypes.Reset_upcoming_Draws_And_Result:
      return {
        ...state,
        upcomingDrawsEvents: null,
        upcomingDrawsEventsError: null,
        loadingUpcomingDraws: null,
        luckyNumbersEventResult: null,
        luckyNumbersEventResultError: null,
        loadingEventResult:  null,
      };
    case SignalRTypes.Get_Suggested_Balls_Request:
      return {
        ...state,
        loadingSuggestedBalls: true,
      };
    case SignalRTypes.Get_Suggested_Balls_Success:
      return {
        ...state,
        loadingSuggestedBalls: false,
        suggestedBalls: action.suggestedBalls
      };
    case SignalRTypes.Get_Suggested_Balls_Error:
      return {
        ...state,
        loadingSuggestedBalls: false,
        suggestedBallsError: action.error
      };
    case SignalRTypes.Update_Lucky_Numbers_Favorite:
      return {
        ...state,
        upcomingDrawsEvents: state.upcomingDrawsEvents && Object.fromEntries(Object.entries(state.upcomingDrawsEvents).map(([eventId, event])=>  { 
					if(event.eventTournament.tournamentId == action.tournamentId){
						return [eventId, { ...event, isFavorite: !event.isFavorite}];
					}else {
						return [eventId, event]; // Return the original entry pair
					}
				})),
      };
    default:
      return { ...state };
  }
};

export default sportTypes;
